var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"avatar"},'div',_vm.getAttributes(_vm.status),false),[_c('img',{staticClass:"img-avatar",attrs:{"loading":"lazy","src":_vm.image && !_vm.isImageError ? _vm.image : _vm.defaultImage,"alt":_vm.alt},on:{"error":_vm.handleImageError}}),_vm._v(" "),_c('span',{class:`${_vm.type}-status ${_vm.statusClass}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }